module.exports = "<gw-faq class=\"gw-faq\"/>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/quoteandbind/common/views/faq-page.html
// module id = 722
// module chunks = 0